import React from 'react';
import DashboardLayout from '../../components/dashboard/DashboardLayout';
import TestimonialManager from '../../components/dashboard/TestimonialManager';

const TestimonialManagerPage = () => {
  return (
    <DashboardLayout>
      <TestimonialManager />
    </DashboardLayout>
  );
};

export default TestimonialManagerPage;